import getApiClient from '@/plugins/api-client'
import { parseFilters } from '@/util/helpers'

export default {
  loadUsers () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
      ...this.filters,
      ...this.pagination.getParams(),
    })

    api.get('users', { params })
      .then(result => {
        this.users = result.data['hydra:member']
        this.pagination.updateData(result.data)
      })
      .catch(error => {
        this.error = error
      })
  },

  clearFilters () {
    this.filters = {}
    this.loadUsers()
  },

  invalidateSessions () {
    const api = getApiClient(this.$store)

    api.post('/invalidate_sessions')
      .then(result => {
        if (result.status === 204) {
          this.invalidatedSessionsSuccess = true
        }
      })
      .catch(error => {
        console.log(error)
      })
  },

  openOrderReport (user) {
    let path
    if (user.roles.includes('ROLE_STUDENT')) {
      path = {
        name: 'Orders',
        params: {
          email: user.email,
        },
      }
    }

    if (user.roles.includes('ROLE_TEACHER')) {
      path = {
        name: 'Subscriptions',
        params: {
          plan: 'all',
          email: user.email,
        },
      }
    }

    this.$router.push(path)
  },

  translateTrafficLightStatus (statusName) {
    let result

    switch (statusName) {
      case 'top':
        result = 'TOP SCHEDULER'
        break
      case 'red':
        result = 'VERMELHO'
        break
      case 'yellow':
        result = 'AMARELO'
        break
      case 'green':
        result = 'VERDE'
    }

    return result
  },

  getTrafficLightsColor (statusName) {
    let result

    switch (statusName) {
      case 'top':
        result = 'blue'
        break
      default:
        result = statusName
    }

    return result
  },
}
